import {
    $, addAction, INIT, LAYOUT,
} from '@situation/setdesign.util';

const VIDEO_CONTROL_LABELS = {
    'video-control--play': 'Play',
    'video-control--pause': 'Pause',
    'video-control--restart': 'Restart',
    'video-control--mute': 'Mute',
    'video-control--unmute': 'Unmute',
};

function updateIcon($button, newSymbolId) {
    if (!$button.length) {
        return;
    }

    const $use = $button.find('use');
    if ($use.length) {
        $use.each((_, useEl) => {
            useEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', newSymbolId);
            useEl.setAttribute('href', newSymbolId);
        });
    }
}

function stampGtmAttributes($controls) {
    $controls.attr('data-gtm', 'bg-video-controls');
    $controls.find('.video-control').each((_, buttonEl) => {
        const $button = $(buttonEl);
        const modifier = Object.keys(VIDEO_CONTROL_LABELS).find((cls) => $button.hasClass(cls));
        if (modifier && !$button.attr('aria-label')) {
            $button.attr('aria-label', VIDEO_CONTROL_LABELS[modifier]);
        }
    });
}

function swapVideoControlIcons() {
    $('.bg-video-controls').each((_, controlsEl) => {
        const $controls = $(controlsEl);
        if ($controls.data('icons-swapped')) {
            return;
        }

        $controls.data('icons-swapped', true);
        stampGtmAttributes($controls);
        updateIcon($controls.find('.video-control--play'), '#icon-control-pause');
        updateIcon($controls.find('.video-control--pause'), '#icon-control-play');
        updateIcon($controls.find('.video-control--mute'), '#icon-control-unmute');
        updateIcon($controls.find('.video-control--unmute'), '#icon-control-mute');
    });
}

function initVideoControls() {
    swapVideoControlIcons();

    if (typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(() => {
            swapVideoControlIcons();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
}

addAction(INIT, initVideoControls);
addAction(LAYOUT, swapVideoControlIcons);
